import { css } from '@emotion/react';
import { Outlet } from 'react-router-dom';

import { safeArea } from '~/common/utils/safe-area.utils';

import type { PropsWithChildren } from 'react';

function EmptyLayout({ children }: PropsWithChildren) {
  return (
    <div css={styles.emptyLayout}>
      <main>{children || <Outlet />}</main>
    </div>
  );
}

const styles = {
  emptyLayout: css`
    position: relative;
    width: 100vw;
    height: 100vh;
    height: 100dvh;

    main {
      min-height: 100vh;
      min-height: 100dvh;
      ${safeArea('top', 'bottom')}
    }
  `,
};

export default EmptyLayout;
